import { useState } from 'react';

import { ModelOfVehicleMovimentation } from 'src/database';
import { dateToString } from 'src/utils/dateToString';
import api from 'src/services/api';

const moment = require('moment');

export const useVehicleReportsController = () => {
	const [loading, setLoading] = useState(false);
	const [vehicleMovimentationData, setVehicleMovimentationData] = useState<ModelOfVehicleMovimentation[]>([]);

	const getVehicleMovimentationData = (vehicleId: string, period?: Date | Date[]) => {
		setLoading(true);
		api.post(`vehicleMovimentationData`, {
			VEICULO: vehicleId,
			period: period,
		})
			.then((response) => {
				setVehicleMovimentationData(response.data);
				setLoading(false);
			})
			.catch((err) => {
				console.log(err);
				setLoading(false);
			});
	};

	const generateVehicleMovimentationReport = (reportData: ModelOfVehicleMovimentation[], period?: Date | Date[]) => {
		const newMovimentations = reportData.map((movimentation) => {
			return {
				CNPJ_ORGAO: movimentation.CNPJ_ORGAO,
				NOME_ORGAO: movimentation.NOME_ORGAO,
				NOME_ORGAOUNIDADE: movimentation.NOME_ORGAOUNIDADE,
				PERIODO: period ? moment(period).format('MM-yyyy') : 'Todos os registros',
				VEICULO: movimentation.VEICULO,
				PLACA: movimentation.PLACA,
				DATARELATORIO: moment(new Date()).format('DD-MM-yyyy HH:mm:ss'),
				DATA: dateToString(movimentation.DATA, 'br'),
				MOTORISTA: movimentation.MOTORISTA,
				QUILOMETRAGEM: movimentation.QUILOMETRAGEM.toString(),
				VALORABASTECIMENTO: movimentation.VALORABASTECIMENTO.toString(),
				QUANTIDADELITROS: movimentation.QUANTIDADELITROS.toString(),
			};
		});

		api.post('vehicleMovimentationReport', newMovimentations, {
			responseType: 'arraybuffer',
		})
			.then((response) => {
				let blob = new Blob([response.data], {
					type: 'application/pdf',
				});

				let url = window.URL.createObjectURL(blob);
				let link = document.createElement('a');
				link.href = url;
				link.download = 'file.pdf';
				window.open(link.href);

				setTimeout(() => {
					window.URL.revokeObjectURL(url);
				}, 100);
				setLoading(false);
			})
			.catch((err) => {
				console.log(err);
			});
	};

	return {
		getVehicleReport: {
			loading,
			vehicleMovimentationData,
		},
		handleVehicleReport: {
			generateVehicleMovimentationReport,
			getVehicleMovimentationData,
		},
	};
};
